import { createFileRoute, redirect } from '@tanstack/react-router';

// /ai opens Durum (merchant screens §2 Redirects).
export const Route = createFileRoute('/ai/')({
  beforeLoad: () => {
    throw redirect({ to: '/ai/status' });
  },
});
